<template>
  <v-container class="pa-0 ma-0" style="width: 100%">
    <v-container class="pa-0 ma-0 d-flex justify-space-between">
      <v-card-text class="pa-3 ma-0 text-body-1 my-3">
        {{ $t("workshopInformationMonthly") }}
      </v-card-text>
      <v-btn
        @click="downloadFile()"
        class="ma-0 pa-0 my-5 me-3"
        color="primary"
        height="28"
      >
        {{ $t("download_insured_workplace_data_files") }}
      </v-btn>
    </v-container>
    <v-container class="pa-0 ma-0 d-flex px-4">
      <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
        <v-card-text class="pa-0 ma-0 text-body-2"
          >{{ $t("insurance") }}:
          <span
            v-if="
              workshop?.items?.workshop.name || workshop?.items?.month || workshop?.items?.year
            "
          >
            {{ workshop?.items?.workshop?.name }} - {{ workshop?.items?.year }}/
            {{ workshop?.items?.month }}</span
          >
          <span v-else>{{ $t("haveNot") }}</span>
        </v-card-text>
        <v-card-text class="pa-0 ma-0 text-body-2"
          >{{ $t("rowContrat") }}:
          <span v-if="workshop.items?.workshop.contract_row">
            {{ workshop.items?.workshop?.contract_row }}</span
          >
          <span v-else> {{ $t("haveNot") }}</span>
        </v-card-text>
        <v-card-text class="pa-0 ma-0 text-body-2"
          >{{ $t("workshopADR") }}:
          <span v-if="workshop?.items?.workshop.address">
            {{ workshop.items?.workshop?.address }}</span
          >
          <span v-else> {{ $t("haveNot") }}</span>
        </v-card-text>
      </v-container>
      <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
        <v-card-text class="pa-0 ma-0 text-body-2"
          >{{ $t("workshopCode") }}:
          <span v-if="workshop?.items?.workshop?.insurance_code">
            {{ workshop?.items?.workshop?.insurance_code }}</span
          >
          <span v-else> {{ $t("haveNot") }}</span>
        </v-card-text>
        <v-card-text class="d-flex pa-0 ma-0 text-body-2"
          >{{ $t("number") }} {{ $t("list") }}:
          <v-text-field
            v-model.number="listNumber"
            type="number"
            dense
            outlined
            hide-details
            class="mr-2"
            height="10"
            style="max-width: 50px; margin-top: -6px"
          ></v-text-field>
        </v-card-text>
      </v-container>
      <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
        <v-card-text class="pa-0 ma-0 text-body-2"
          >{{ $t("workshopName") }}:
          <span v-if="workshop?.items?.workshop?.name">
            {{ workshop?.items?.workshop?.name }}</span
          >
          <span v-else>{{ $t("haveNot") }}</span>
        </v-card-text>
        <v-card-text class="pa-0 ma-0 text-body-2"
          >{{ $t("count_persons") }}:
          <span v-if="workshop?.items?.employee_count">
            {{ workshop?.items?.employee_count }}</span
          >
          <span v-else>{{ $t("haveNot") }}</span>
        </v-card-text>
      </v-container>
    </v-container>
    <v-divider class="my-3"></v-divider>
    <v-container class="pa-0 ma-0 d-flex px-4">
      <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
        <v-card-text class="pa-0 ma-0 text-body-2"
          >{{ $t("totalDailyWage") }}:
          <span v-if="totalDailyWage != null">
            {{ totalDailyWage.toLocaleString() }}</span
          >
          <span v-else>{{ $t("haveNot") }}</span>
        </v-card-text>
        <v-card-text class="pa-0 ma-0 text-body-2"
          >{{ $t("totalMonthlyWage") }}:
          <span v-if="totalMonthlyWage != null">
            {{ totalMonthlyWage.toLocaleString() }}</span
          >
          <span v-else>{{ $t("haveNot") }}</span>
        </v-card-text>
        <v-card-text class="pa-0 ma-0 text-body-2"
          >{{ $t("PremiumRate") }}:
          <span v-if="totalInsuranceRate != null">
            {{ totalInsuranceRate.toLocaleString() }}</span
          >
          <span v-else>{{ $t("haveNot") }}</span>
        </v-card-text>
      </v-container>
      <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
        <v-card-text class="pa-0 ma-0 text-body-2"
          >{{ $t("total_monthly_covered_benefits") }}:
          <span v-if="totalBenefitCovered != null">
            {{ totalBenefitCovered.toLocaleString() }}</span
          >
          <span v-else>{{ $t("haveNot") }}</span>
        </v-card-text>
        <v-card-text class="pa-0 ma-0 text-body-2"
          >{{ $t("total_monthly_covered_benefits&wages") }}:
          <span v-if="totalBenefitAndWage != null">
            {{ totalBenefitAndWage.toLocaleString() }}</span
          >
          <span v-else>{{ $t("haveNot") }}</span>
        </v-card-text>
        <v-card-text class="pa-0 ma-0 text-body-2"
          >{{ $t("total_monthly_benefits&wages") }}:
          <span v-if="total != null"> {{ total.toLocaleString() }}</span>
          <span v-else>{{ $t("haveNot") }}</span>
        </v-card-text>
      </v-container>
      <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
        <v-card-text class="pa-0 ma-0 text-body-2"
          >{{ $t("insured’s_premium_share") }}:
          <span v-if="bime != null"> {{ bime.toLocaleString() }}</span>
          <span v-else>{{ $t("haveNot") }}</span>
        </v-card-text>
        <v-card-text class="pa-0 ma-0 text-body-2"
          >{{ $t("employer’s_insurance_contribution") }}:
          <span v-if="coBime != null"> {{ coBime.toLocaleString() }}</span>
          <span v-else>{{ $t("haveNot") }}</span>
        </v-card-text>
        <v-card-text class="pa-0 ma-0 text-body-2"
          >{{ $t("unemployment_insurance") }}:
          <span v-if="unemployment != null"> {{ unemployment.toLocaleString() }}</span>
          <span v-else>{{ $t("haveNot") }}</span>
        </v-card-text>
      </v-container>
    </v-container>
  </v-container>
</template>
<script>
export default {
  props: {
    workshop: {
      type: [Object, Array],
      default: () => ({}),
    },
    employee: {
      type: [Object, Array],
      default: () => ({}),
    },
  },
  data() {
    return {
      listNumber: 1,
    };
  },
  computed: {
    totalDailyWage() {
      if (!this.employee?.items) return 0;
      return this.employee.items.reduce((sum, item) => {
        return sum + (Number(item.DSW_ROOZ) || 0);
      }, 0);
    },
    totalMonthlyWage() {
      if (!this.employee?.items) return 0;
      return this.employee.items.reduce((sum, item) => {
        return sum + (Number(item.DSW_MAH) || 0);
      }, 0);
    },
    totalInsuranceRate() {
      if (!this.employee?.items) return 0;
      return this.employee.items.reduce((sum, item) => {
        return sum + (Number(item.DSW_BIME) || 0);
      }, 0);
    },
    totalBenefitCovered() {
      if (!this.employee?.items) return 0;
      return this.employee.items.reduce((sum, item) => {
        return sum + (Number(item.DSW_MAZ) || 0);
      }, 0);
    },
    total() {
      if (!this.employee?.items) return 0;
      return this.employee.items.reduce((sum, item) => {
        return sum + (Number(item.DSW_TOTL) || 0);
      }, 0);
    },
    bime() {
      if (!this.employee?.items) return 0;
      return this.employee.items.reduce((sum, item) => {
        return sum + (Number(item.employee_insurance) || 0);
      }, 0);
    },
    coBime() {
      if (!this.employee?.items) return 0;
      return this.employee.items.reduce((sum, item) => {
        return sum + (Number(item.company_insurance) || 0);
      }, 0);
    },
    unemployment() {
      if (!this.employee?.items) return 0;
      return this.employee.items.reduce((sum, item) => {
        return sum + (Number(item.company_insurance) || 0);
      }, 0);
    },
    totalBenefitAndWage() {
      if (!this.employee?.items) return 0;
      return this.employee.items.reduce((sum, item) => {
        const maz = Number(item.DSW_MAZ) || 0;
        const mah = Number(item.DSW_MAH) || 0;
        return sum + maz + mah;
      }, 0);
    },
  },
  methods: {
    downloadFile() {
      const app = this;
      app.loading = true;
      const id_ = app.$route.query.id;
      const number = this.listNumber;
      let param = "download";
      app.$axios
        .get(app.$endpoint + "salary/insurance/" + id_, {
          params: {
            export: param,
            list_number: number,
          },
          responseType: "arraybuffer",
        })
        .then((response) => {
          // create a blob from response
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          // create a link element
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          // set file name
          link.download = "insured_workplace_data.zip";
          // trigger download
          link.click();
          // cleanup
          window.URL.revokeObjectURL(link.href);
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.report-container {
  width: 100%;
  background: #f5f5f5;
  padding: 25px;
  direction: rtl;
  font-family: tahoma;
}

.report-title {
  text-align: right;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 20px;
}

.report-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  border: 1px solid #ddd;
}

.report-item {
  display: flex;
  flex-direction: column;
  font-size: 13px;
}

.label {
  color: #777;
  margin-bottom: 5px;
}

.value {
  font-weight: 600;
  color: #333;
}

.report-footer {
  margin-top: 20px;
  padding: 15px;
  background: #fff;
  border: 1px solid #ddd;
  font-weight: bold;
  text-align: left;
}
</style>
